// extracted by mini-css-extract-plugin
export default {"rcb":"ReceiptCheckBox_rcb__Yo-Pn","rcb__input":"ReceiptCheckBox_rcb__input__lkW2Q","rcb__check":"ReceiptCheckBox_rcb__check__rnr3G"};